import React, { Component } from 'react';
import { Glyphicon } from 'react-bootstrap'
import { BarChart, Bar, LabelList, Tooltip } from 'recharts'
import { RingLoader } from 'react-spinners'
import Modal from 'react-responsive-modal'
import ReactTable from 'react-table'
import ToEditAdmin from './ToEditAdmin'
import matchSorter from 'match-sorter';

import { observer } from 'mobx-react';

const AdminDashboard = observer( class AdminDashboard extends Component {

	constructor() {
		super()
		this.state = {
			uid:null,
			deals: null,
			open: false,
			toEdit: null
		}
		this.refresh = this.refresh.bind(this)
		this.engageModal = this.engageModal.bind(this)
		this.editEvent = this.editEvent.bind(this)
		this.editUnlistedEvent = this.editUnlistedEvent.bind(this)
		this.cancelModal = this.cancelModal.bind(this)
		this.duplicateListing = this.duplicateListing.bind(this)
	}

	componentDidMount(){
		this.refresh()
	}

	refresh () {
		let { myStores } = this.props;
		let { mainStore } = myStores;

		mainStore.getAllListings();

	}

	engageModal(){
		this.setState({open: !this.state.open})
	}

	cancelModal(){
		this.setState({open: !this.state.open})
	}

	editEvent(deal){
		this.setState({toEdit: deal, editType:'listed'}, () => {
			console.log('toedit',this.state.toEdit)
			this.engageModal('listed')
		})
	}

	editUnlistedEvent(deal){
		this.setState({toEdit: deal, editType:'unlisted'}, () => {
			console.log('toedit',this.state.toEdit)
			this.engageModal('unlisted')
		})
	}

	duplicateListing(deal) {
		// reset/remove all necessary existing keys
		delete deal._id;
		deal.deal_ids = [];
		deal.save_count = 0;
		deal.details_opened = 0;
		deal.deal_code = Math.random().toString(36).slice(4,8)
		console.log('duplicate deal', deal);

	}

	render() {
		let { myStores } = this.props;
		let { mainStore } = myStores;


		let columns = [
			{
				Header: "Code",
				accessor: 'deal_code',
				width: 50,
				filterable: false
			},
			{
				Header: "Vendor",
				accessor: 'vendor',
				width: 100,
				style:{
					all: 'unset'
				},
				filterMethod: (filter,rows) =>
	            	matchSorter(rows, filter.value, { keys: ['vendor'] }),
	          	filterAll: true
			},
			{
				Header: "Deal Title",
				accessor: 'dealTitle',
				width: 150,
				style:{
					all: 'unset'
				},
				filterMethod: (filter,rows) =>
	            	matchSorter(rows, filter.value, { keys: ['dealTitle'] }),
	          	filterAll: true
			},
			{
				Header: "Description",
				accessor: 'description',
				width: 300,
				style: {
					all: 'unset'
				},
				filterable: false
			},
			{
				Header: "$",
				accessor: 'price',
				Cell: row => (<p>{ row.value ? (row.value/100).toFixed(2) : null }</p>),
				width: 50,
				filterable: false
			},
			{
				Header: "%",
				accessor: 'percent',
				width: 50,
				filterable: false
			},
			{
				Header: "Total Saved",
				accessor: 'save_count',
				width: 50,
				filterable: false
			},
			{
				Header: "Redemptions",
				accessor: 'deal_ids',
				Cell: row => (<p>{row.value ? row.value.length : 0}</p>),
				width: 50,
				filterable: false
			},
			{
				Header: "Impressions",
				accessor: 'details_opened',
				Cell: row => (<p>{row.value ? row.value : 0}</p>),
				width: 50,
				filterable: false
			},
			{
				Cell: row => (<button className='btn btn-primary' onClick={() => this.editEvent(row.original)}>Edit</button>),
				filterable: false
			},
			{
				Cell: row => (<button className='btn btn-danger' onClick={() => mainStore.deleteEvent(row.original,'events')}>Delete</button>),
				filterable: false
			},
			{
				Cell: row => (<button className='btn btn-default' onClick={() => mainStore.unlistEvent(row.original)}>Unlist</button>),
				filterable: false
			},
			{
				Cell: row => (<button className='btn btn-default' onClick={() => mainStore.duplicateEvent(row.original)}>Duplicate</button>),
				filterable: false
			}
		]

		let unlistedCols = [
			{
				Header: "Code",
				accessor: 'deal_code',
				width: 50,
				filterable: false
			},
			{
				Header: "Vendor",
				accessor: 'vendor',
				width: 100,
				style:{
					all: 'unset'
				},
				filterMethod: (filter,rows) =>
	            	matchSorter(rows, filter.value, { keys: ['vendor'] }),
	      filterAll: true
			},
			{
				Header: "Deal Title",
				accessor: 'dealTitle',
				width: 150,
				style:{
					all: 'unset'
				},
				filterMethod: (filter,rows) =>
	            	matchSorter(rows, filter.value, { keys: ['dealTitle'] }),
	      filterAll: true
			},
			{
				Header: "Description",
				accessor: 'description',
				width: 200,
				style: {
					all: 'unset'
				},
				filterMethod: (filter,rows) =>
	            	matchSorter(rows, filter.value, { keys: ['description'] }),
	      filterAll: true,
				filterable: true
			},
			{
				Header: "Days",
				accessor: 'days',
				Cell: row => (
					<div>
					<p>
						{
							row.value.Monday ? "Monday" : null
						}
					</p>
					<p>
						{
							row.value.Tuesday ? "Tuesday" : null
						}
					</p>
					<p>
						{
							row.value.Wednesday ? "Wednesday" : null
						}
					</p>
					<p>
						{
							row.value.Thursday ? "Thursday" : null
						}
					</p>
					<p>
						{
							row.value.Friday ? "Friday" : null
						}
					</p>
					<p>
						{
							row.value.Saturday ? "Saturday" : null
						}
					</p>
					<p>
						{
							row.value.Sunday ? "Sunday" : null
						}
					</p>
					</div>
				),
				style: {
					all: 'unset'
				},
				filterable: false
			},
			{
				Header: "$",
				accessor: 'price',
				Cell: row => (<p>{ row.value ? (row.value/100).toFixed(2) : null }</p>),
				width: 50,
				filterable: false
			},
			{
				Header: "%",
				accessor: 'percent',
				width: 50,
				filterable: false
			},
			{
				Header: "Total Saved",
				accessor: 'save_count',
				width: 50,
				filterable: false
			},
			{
				Header: "Redemptions",
				accessor: 'deal_ids',
				Cell: row => (<p>{row.value ? row.value.length : 0}</p>),
				width: 50,
				filterable: false
			},
			{
				Header: "Impressions",
				accessor: 'details_opened',
				Cell: row => (<p>{row.value ? row.value : 0}</p>),
				width: 50,
				filterable: false
			},
			{
				Cell: row => (<button className='btn btn-primary' onClick={() => this.editUnlistedEvent(row.original)}>Edit</button>),
				filterable: false
			},
			{
				Cell: row => (<button className='btn btn-danger' onClick={() => mainStore.deleteEvent(row.original,"unlistedEvents")}>Delete</button>),
				filterable: false
			},
			{
				Cell: row => (<button className='btn btn-success' onClick={() => mainStore.relistEvent(row.original)}>List Deal</button>),
				filterable: false
			},
			{
				Cell: row => (<button className='btn btn-default' onClick={() => mainStore.duplicateEvent(row.original)}>Duplicate</button>),
				filterable: false
			}

		]

		if(mainStore.listings.listedEvents){
			let getReedem = (d) => {
				if(d.deal_ids){
					return d.deal_ids.length
				} else {
					return 0
				}
			}
				return (
					<div style={styles.container}>
						<h2 className='text-primary'>Redemptions | Saved | Impressions</h2>
						<Glyphicon onClick={this.refresh} glyph='refresh' style={{color:'#33F9FF'}} />
						<hr />
						<BarChart
							width={window.innerWidth - 100}
							height={400}
							data={mainStore.listings.listedEvents.slice()}
						>
							<Tooltip
								itemStyle={{color: 'black'}}
								labelStyle={{fontWeight: 'bold'}}
								content={<CustomToolTip  />}
							/>

							<Bar dataKey='save_count'
								 fill='#33F9FF'
								 animationDuration={3000}>
								<LabelList dataKey='save_count' />
							</Bar>

							<Bar dataKey={getReedem}
								 fill='#33F9DD'
								 animationDuration={3000}>
								<LabelList dataKey={getReedem} />
							</Bar>

							<Bar dataKey='details_opened'
								 fill='#7a33f9'
								 animationDuration={3000}>
								<LabelList dataKey='details_opened' />
							</Bar>

						</BarChart>

					<hr/>

					<h1>Listed Events</h1>
						<div style={{width: '100%'}}>
						<ReactTable
							data={mainStore.listings.listedEvents.slice()}
							filterable
							defaultFilterMethod={(filter, row) =>
                     		String(row[filter.id]) === filter.value}
							columns={columns}
							className="-striped -highlight"
						/>
						</div>

					{
						mainStore.listings.unlistedEvents ?
						<div style={{width: '100%', marginTop: 20}}>
						<h1 className='text-center'>Unlisted Deals</h1>
							<ReactTable
								data={mainStore.listings.unlistedEvents.slice()}
								filterable
								columns={unlistedCols}
								className="-striped -highlight"
								defaultPageSize={10}
							/>
						</div>
						: null
					}


					<div style={{paddingTop: "20px"}}>
					<Modal
						styles={styles.modal}
						open={this.state.open}
						onClose={this.engageModal}
						animationDuration={1000}
						>
						<ToEditAdmin
							{ ...this.props }
							toEdit= { this.state.toEdit || null }
							refresh={this.refresh}
							closeModal={this.cancelModal}
							collection={ this.state.editType == "listed" ? "events" : "unlistedEvents" }
						/>
					</Modal>
					</div>
					</div>
				)
			}


			return (
				<div style={styles.ringCont}>
					<RingLoader color='lightblue' />
				</div>
			)
		}
});

const CustomToolTip = observer( ({label,payload}) => {
	if(payload && payload.length > 0){
		return (

			<div style={{backgroundColor: '#3393ff', padding: 15, borderRadius: 5}}>
				<p style={{color: 'white'}}>{payload[0].payload.vendor}</p>
				<p style={{color: 'white'}}>{payload[0].payload.dealTitle}</p>
				<p style={{color: 'white'}}>Saved: {payload[0].payload.save_count ? payload[0].payload.save_count : 0}</p>
				<p style={{color: 'white'}}>Redeemed: {payload[0].payload.deal_ids ? payload[0].payload.deal_ids.length : 0 }</p>
				<p style={{color: 'white'}}>Impressions: {payload[0].payload.details_opened ? payload[0].payload.details_opened : 0 }</p>
			</div>
		)
	}

	return (
		<div>
			<p>No payload</p>
		</div>
	)


})

const styles = {
	container: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		marginBottom: 100,
		marginTop: 200
	},
	ringCont: {
		display: 'flex',
		justifyContent: 'center'
	}
}


export default AdminDashboard



// WEBPACK FOOTER //
// ./src/components/admin/AdminDashboard.js